// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__tJqB7","placeHolderShimmer":"ReportFilter_placeHolderShimmer__aB6P6"};